import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import React, { useState } from "react";
import { useTranslation } from "@coworker/locales";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import { EditArticlesModal } from "@coworker/app/src/components/RoomSettings/Organisms/Modals/EditArticlesModal";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";

interface ItemEditQuantityProps {
  media: Media;
  article: AggregatedArticle;
}

export const ItemEditQuantity = ({ media, article }: ItemEditQuantityProps) => {
  const { t } = useTranslation();
  const [shouldOpenEditModal, setShouldOpenEditModal] =
    useState<boolean>(false);
  return (
    <>
      <FixaButton
        size="small"
        text={t("editQuantityString")}
        onClick={() => {
          setShouldOpenEditModal(true);
        }} // open modal to edit quantity
      />
      {shouldOpenEditModal && (
        <EditArticlesModal
          aggregatedArticle={article}
          media={media}
          onClose={() => {
            setShouldOpenEditModal(false);
          }}
        />
      )}
    </>
  );
};
